module.exports = __webpack_public_path__ + "img/slider-mainbg-001.5ed7c338.jpg";